import { NewMedicalLeaveUpdatePageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import NewMedicalLeaveUpdate from 'modules/timeoff/components/NewMedicalLeaveUpdate'
import { useOnClose } from 'modules/timeoff/hooks/useOnClose'

const NewMedicalLeaveUpdatePage = () => {
  const { leave_id: leaveId } = useStrictParams<'leave_id'>()
  const onClose = useOnClose()

  const { data, loading } = useQuery(NewMedicalLeaveUpdatePageDocument, {
    variables: {
      leaveId: leaveId,
    },
  })

  const leaveEmployee = data?.timeoff.leave?.employee

  if (!leaveEmployee) {
    throw new Error('Leave employee not found')
  }

  return (
    <NewMedicalLeaveUpdate
      leaveId={leaveId}
      onClose={onClose}
      loading={loading}
      leaveEmployeeId={leaveEmployee.id}
    />
  )
}

export default NewMedicalLeaveUpdatePage
